(() => {
  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  document.querySelectorAll('[data-catalog-form]').forEach(form => {
    if (form.dataset.catalogInitialized) return;
    form.dataset.catalogInitialized = 'true';
    form.classList.add('is-enhanced');
    const panel = form.querySelector('[data-fallback-panel]') || form.querySelector('[data-catalog-filter-panel]');
    if (panel && matchMedia('(max-width: 639px)').matches && !panel.querySelector('input:checked, input[type="number"][value]')) panel.open = false;
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewTheme) { const input = create('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = previewTheme; form.append(input); }
    if (!form.hasAttribute('data-catalog-fallback')) {
      form.querySelector('[data-catalog-sort]')?.addEventListener('change', () => form.requestSubmit());
      form.addEventListener('submit', event => {
        const minimum = form.querySelector('input[name$="price.gte"]');
        const maximum = form.querySelector('input[name$="price.lte"]');
        if (minimum?.value && maximum?.value && Number(minimum.value) > Number(maximum.value)) [minimum.value, maximum.value] = [maximum.value, minimum.value];
        if (!form.reportValidity()) { event.preventDefault(); return; }
        form.querySelectorAll('input[type="number"]').forEach(input => { if (!input.value) input.disabled = true; });
      });
      return;
    }
    const section = form.closest('[data-catalog-page]');
    const grid = section.querySelector('[data-catalog-results]');
    const chips = section.querySelector('[data-fallback-chips]');
    const fields = form.querySelector('[data-fallback-fields]');
    const status = form.querySelector('[data-fallback-status]');
    const translations = JSON.parse(form.querySelector('[data-catalog-translations]').textContent);
    const count = form.querySelector('[data-catalog-count]');
    const cache = new Map();
    const keys = ['par4_vendor', 'par4_min', 'par4_max', 'par4_in_stock'].filter(key => form.elements.namedItem(key));
    const initialLocation = location.href;
    const originalGrid = grid.cloneNode(true);
    const originalCount = count.textContent;
    const nativePagination = section.querySelector('[data-catalog-pagination]');
    let clientPagination;
    let requestSequence = 0;
    let isFiltered = false;
    fields.disabled = false;
    panel.hidden = false;
    const config = JSON.parse(document.querySelector('#storefront-config')?.textContent || '{}');
    const money = value => new Intl.NumberFormat(config.locale || document.documentElement.lang || 'fr', { style: 'currency', currency: config.currency || 'EUR' }).format(value / 100);
    const nativeSignature = () => JSON.stringify([...new FormData(form)].filter(([key]) => key.startsWith('filter.')).sort(([a, av], [b, bv]) => a.localeCompare(b) || String(av).localeCompare(String(bv))));
    const initialNativeSignature = nativeSignature();
    function hydrateControls(url) {
      for (const key of keys) {
        const input = form.elements.namedItem(key);
        const value = url.searchParams.get(key) || '';
        if (input.type === 'checkbox') input.checked = value === '1';
        else {
          if (input.tagName === 'SELECT' && value && ![...input.options].some(option => option.value === value)) input.add(new Option(value, value));
          input.value = value;
        }
      }
      const sort = form.elements.namedItem('sort_by');
      if (sort && url.searchParams.has('sort_by')) sort.value = url.searchParams.get('sort_by');
    }
    function stateFromControls() {
      const data = new FormData(form);
      const nativeOptions = new Map();
      for (const [key, value] of data) if (key.startsWith('filter.v.option.')) { const name = key.slice('filter.v.option.'.length); nativeOptions.set(name, [...(nativeOptions.get(name) || []), value]); }
      return { vendor: data.get('par4_vendor') || '', min: data.get('par4_min') || '', max: data.get('par4_max') || '', inStock: data.get('par4_in_stock') === '1', sort: data.get('sort_by') || '', nativeOptions, nativeMin: data.get('filter.v.price.gte') || '', nativeMax: data.get('filter.v.price.lte') || '', nativeStock: data.getAll('filter.v.availability') };
    }
    function makeUrl(state, page = 1) {
      const url = new URL(form.action, location.origin);
      for (const [key, value] of new FormData(form)) if (!key.startsWith('par4_') && value) url.searchParams.append(key, value);
      if (state.vendor) url.searchParams.set('par4_vendor', state.vendor);
      if (state.min !== '') url.searchParams.set('par4_min', state.min);
      if (state.max !== '') url.searchParams.set('par4_max', state.max);
      if (state.inStock) url.searchParams.set('par4_in_stock', '1');
      if (page > 1) url.searchParams.set('par4_page', page);
      return url;
    }
    function showStatus(message, error = false) {
      status.hidden = !message;
      status.textContent = message;
      status.classList.toggle('is-error', error);
    }
    async function loadEntries(sort) {
      const url = new URL(form.action, location.origin);
      for (const [key, value] of new FormData(form)) if (!key.startsWith('par4_') && value) url.searchParams.append(key, value);
      url.searchParams.set('view', 'par4-catalog');
      if (sort) url.searchParams.set('sort_by', sort);
      const cacheKey = url.href;
      if (cache.has(cacheKey)) return cache.get(cacheKey);
      const request = (async () => {
        const entries = [];
        const seenPages = new Set();
        const seenProducts = new Set();
        let next = url;
        let expected = 0;
        while (next) {
          if (next.origin !== location.origin || seenPages.has(next.href)) throw new Error('Invalid catalog pagination');
          seenPages.add(next.href);
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 30000);
          let html;
          try {
            const response = await fetch(next, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: controller.signal });
            if (!response.ok) throw new Error('Catalog unavailable');
            html = await response.text();
          } finally { clearTimeout(timeout); }
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const source = parsed.querySelector('[data-catalog-source]');
          if (!source) throw new Error('Catalog response missing');
          expected = Math.max(expected, Number(source.dataset.catalogTotal) || 0);
          for (const entry of source.querySelectorAll('[data-catalog-entry]')) {
            const product = JSON.parse(entry.querySelector('[data-catalog-product]').textContent);
            const card = entry.querySelector('.product-card');
            if (!card || seenProducts.has(String(product.id))) continue;
            seenProducts.add(String(product.id));
            entries.push({ product, card });
          }
          if (source.dataset.nextUrl) {
            next = new URL(source.dataset.nextUrl, url);
            next.searchParams.set('view', 'par4-catalog');
            for (const key of new Set(url.searchParams.keys())) if (key !== 'page') { next.searchParams.delete(key); url.searchParams.getAll(key).forEach(value => next.searchParams.append(key, value)); }
          } else next = null;
        }
        if (entries.length < expected) throw new Error('Incomplete catalog');
        return entries;
      })();
      cache.set(cacheKey, request);
      try { return await request; } catch (error) { cache.delete(cacheKey); throw error; }
    }
    function matches(product, state, ignoreVendor = false) {
      if (!ignoreVendor && state.vendor && product.vendor !== state.vendor) return false;
      const variants = product.variants?.length ? product.variants : [product];
      const minimum = state.min !== '' ? state.min : state.nativeMin;
      const maximum = state.max !== '' ? state.max : state.nativeMax;
      const normalize = value => String(value).toLocaleLowerCase().trim();
      return variants.some(variant => {
        if (state.inStock && !variant.available) return false;
        if (state.nativeStock.length && !state.nativeStock.includes(variant.available ? '1' : '0')) return false;
        if (minimum !== '' && variant.price < Number(minimum) * 100) return false;
        if (maximum !== '' && variant.price > Number(maximum) * 100) return false;
        for (const [name, values] of state.nativeOptions) {
          const index = (product.optionNames || []).findIndex(option => normalize(option) === normalize(name));
          if (index < 0 || !values.some(value => normalize(value) === normalize(variant.options?.[index]))) return false;
        }
        return true;
      });
    }
    function updateBrands(entries, state) {
      const brands = new Map();
      entries.forEach(({ product }) => { if (product.vendor) brands.set(product.vendor, (brands.get(product.vendor) || 0) + (matches(product, state, true) ? 1 : 0)); });
      const select = form.elements.namedItem('par4_vendor');
      if (!select) return;
      select.replaceChildren(new Option(translations.allBrands, ''));
      [...brands].sort(([a], [b]) => a.localeCompare(b)).forEach(([brand, total]) => { const option = new Option(`${brand} (${total})`, brand); option.disabled = total === 0 && brand !== state.vendor; select.add(option); });
      if (state.vendor && !brands.has(state.vendor)) select.add(new Option(`${state.vendor} (0)`, state.vendor));
      select.value = state.vendor;
    }
    function renderChips(state) {
      chips.replaceChildren();
      const items = [];
      if (state.vendor) items.push({ label: `${translations.brand} : ${state.vendor}`, keys: ['par4_vendor'] });
      if (state.inStock) items.push({ label: translations.stock, keys: ['par4_in_stock'] });
      if (state.min !== '' || state.max !== '') items.push({ label: `${translations.price} : ${money(Number(state.min || 0) * 100)} — ${state.max !== '' ? money(Number(state.max) * 100) : '∞'}`, keys: ['par4_min', 'par4_max'] });
      for (const item of items) {
        const button = create('button', 'catalog-filter-chip', item.label);
        button.type = 'button';
        button.setAttribute('aria-label', `${translations.remove} : ${item.label}`);
        const remove = create('span', '', '×'); remove.setAttribute('aria-hidden', 'true'); button.append(remove);
        button.addEventListener('click', () => { item.keys.forEach(key => { const input = form.elements.namedItem(key); if (input.type === 'checkbox') input.checked = false; else input.value = ''; }); apply(1, true); });
        chips.append(button);
      }
      chips.hidden = !items.length;
      const badge = form.querySelector('[data-fallback-count]'); badge.hidden = !items.length; badge.textContent = items.length;
    }
    function renderPagination(state, page, total) {
      clientPagination?.remove();
      if (nativePagination) nativePagination.hidden = true;
      if (total < 2) return;
      clientPagination = create('nav', 'catalog-pagination');
      clientPagination.setAttribute('aria-label', translations.pagination);
      const list = create('ul'); list.setAttribute('role', 'list');
      function link(number, text, label) {
        const li = create('li');
        const item = create(number === page ? 'span' : 'a', number === page ? 'is-current' : '', text);
        item.setAttribute('aria-label', label);
        if (number === page) item.setAttribute('aria-current', 'page');
        else {
          item.href = makeUrl(state, number);
          item.addEventListener('click', event => { if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); apply(number, true, true); });
        }
        li.append(item); list.append(li);
      }
      if (page > 1) link(page - 1, '←', translations.previous);
      const pages = new Set([1, total, page - 1, page, page + 1]);
      let last = 0;
      [...pages].filter(number => number >= 1 && number <= total).sort((a, b) => a - b).forEach(number => { if (last && number > last + 1) { const li = create('li'); li.append(create('span', '', '…')); list.append(li); } link(number, number, `${translations.page} ${number}`); last = number; });
      if (page < total) link(page + 1, '→', translations.next);
      clientPagination.append(list, create('p', '', `${translations.page} ${page} ${translations.of} ${total}`));
      grid.after(clientPagination);
    }
    async function apply(page = 1, push = false, focus = false) {
      const sequence = ++requestSequence;
      const state = stateFromControls();
      if (state.min !== '' && state.max !== '' && Number(state.min) > Number(state.max)) { [state.min, state.max] = [state.max, state.min]; form.elements.namedItem('par4_min').value = state.min; form.elements.namedItem('par4_max').value = state.max; }
      if (!form.reportValidity()) return;
      grid.setAttribute('aria-busy', 'true');
      showStatus(translations.loading);
      try {
        const entries = await loadEntries(state.sort);
        if (sequence !== requestSequence) return;
        const filtered = entries.filter(({ product }) => matches(product, state));
        const total = Math.max(1, Math.ceil(filtered.length / 24));
        page = Math.min(total, Math.max(1, Number(page) || 1));
        grid.replaceChildren(...filtered.slice((page - 1) * 24, page * 24).map(({ card }) => card.cloneNode(true)));
        if (!filtered.length) { const empty = create('div', 'empty-state catalog-empty'); empty.append(create('h2', '', translations.emptyTitle), create('p', '', translations.emptyDescription)); const reset = create('button', 'button button--dark', translations.clear); reset.type = 'button'; reset.addEventListener('click', clear); empty.append(reset); grid.append(empty); }
        count.textContent = `${filtered.length} ${filtered.length === 1 ? translations.singular : translations.plural}`;
        updateBrands(entries, state);
        renderChips(state);
        renderPagination(state, page, total);
        isFiltered = true;
        showStatus('');
        if (push) history.pushState({}, '', makeUrl(state, page));
        document.dispatchEvent(new CustomEvent('par4:catalog-updated', { detail: { container: grid } }));
        if (focus) { grid.setAttribute('tabindex', '-1'); grid.focus({ preventScroll: true }); grid.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' }); }
      } catch { if (sequence === requestSequence) { showStatus(translations.failed, true); panel.open = true; } }
      finally { if (sequence === requestSequence) grid.removeAttribute('aria-busy'); }
    }
    function clear() {
      if ([...new FormData(form)].some(([key, value]) => key.startsWith('filter.') && value)) { location.assign(form.dataset.catalogClearUrl || form.action); return; }
      keys.forEach(key => { const input = form.elements.namedItem(key); if (input.type === 'checkbox') input.checked = false; else input.value = ''; });
      apply(1, true);
    }
    form.querySelector('[data-fallback-clear]').addEventListener('click', clear);
    form.addEventListener('submit', event => {
      if (nativeSignature() !== initialNativeSignature) {
        form.querySelectorAll('input[type="number"]').forEach(input => { if (!input.value) input.disabled = true; });
        return;
      }
      event.preventDefault(); apply(1, true);
    });
    form.querySelector('[data-catalog-sort]')?.addEventListener('change', () => form.requestSubmit());
    hydrateControls(new URL(location.href));
    if (keys.some(key => new URL(location.href).searchParams.has(key)) || new URL(location.href).searchParams.has('par4_page')) apply(new URL(location.href).searchParams.get('par4_page'));
    window.addEventListener('popstate', () => {
      const url = new URL(location.href);
      hydrateControls(url);
      if (url.href !== initialLocation || keys.some(key => url.searchParams.has(key)) || url.searchParams.has('par4_page')) apply(url.searchParams.get('par4_page') || url.searchParams.get('page'));
      else if (isFiltered) {
        requestSequence++;
        grid.replaceChildren(...[...originalGrid.children].map(card => card.cloneNode(true)));
        count.textContent = originalCount;
        if (nativePagination) nativePagination.hidden = false;
        clientPagination?.remove(); chips.hidden = true;
        form.querySelector('[data-fallback-count]').hidden = true;
        isFiltered = false; showStatus(''); grid.removeAttribute('aria-busy');
        document.dispatchEvent(new CustomEvent('par4:catalog-updated', { detail: { container: grid } }));
      }
    });
  });
})();
